.homeBubbles
{
	text-align: center;
	overflow-x: auto;
	display: flex;
	margin: 0 auto;
	padding: 0 $spacer;

	@include media-breakpoint-up(lg)
	{
		display: none;
	}

	a
	{
		color: $alt-link-color;
		margin: map-get($spacers, 3);
		font-size: $font-size-sm;
		flex-basis: 0;

		&:first-child {
			margin-left: auto !important;
		}

		&:last-child {
			margin-right: auto !important;
		}

		&:hover,
		&:focus
		{
			color: $alt-link-hover-color;
		}
	}

	img
	{
		display: block;
		margin: 0 auto map-get($spacers, 3);
	}
}